const ConversationListTrashIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true">
		<path d="M3 6h18" />
		<path d="M8 6V4h8v2" />
		<path d="M19 6l-1 14H6L5 6" />
		<path d="M10 11v6" />
		<path d="M14 11v6" />
	</svg>
);

export default ConversationListTrashIcon;
